import React from 'react';
import { useSelector } from 'react-redux';

import { LINKS } from '../Constants';
import { capitalize } from '../Utils/otherUtils';

import ExpandableContent from './ExpandableContent';

const StreetView = (props) => {
  const { area: { name, coordinates } } = props;
  const {
    text: { streetView: pageText },
  } = useSelector(state => state.Language);

  const src = `${LINKS.STREET_VIEW}${coordinates.lat},${coordinates.long}`;

  return (
    <div className="street-view">
      <ExpandableContent
        id={pageText.heading}
        header={capitalize(name) + pageText.heading}
      >
        <div className="main-text-content">
          <p className="preamble">
            {pageText.preamble}
          </p>
        </div>
        <div className="full-width-item">
          <div className="iframe-wrapper">
            <iframe
              title={pageText.heading}
              aria-label={pageText.heading}
              src={src}
              allowFullScreen
            />
          </div>
        </div>
      </ExpandableContent>
    </div>
  );
};

export default StreetView;



// WEBPACK FOOTER //
// ./src/Components/StreetView.js